var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRightThin = function SvgArrowRightThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    "data-name": "Open Menu_big",
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Open Menu_big"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.526 4.84a.5.5 0 0 1 .357.15l5.974 6.08a.5.5 0 0 1 0 .7l-5.974 6.08a.5.5 0 0 1-.707.006.5.5 0 0 1-.006-.706l5.63-5.73-5.63-5.73a.5.5 0 0 1 .357-.85z",
    "data-name": "Path 11603"
  }))));
};
export default SvgArrowRightThin;